import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VBtn,{staticClass:"custom-button",attrs:{"block":"","color":"#0054A6"},on:{"click":_vm.handleClick}},[_c(VIcon,{attrs:{"left":""}},[_vm._v("mdi-calendar")]),_vm._v(" "+_vm._s(_vm.buttonText)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }